import { TVacancy } from "../../../../store/vacancy/types";
import CustomButton from "../../../UI/Buttons/CustomButton";
import Block from "../../../UI/Icons/Block";
import Copy from "../../../UI/Icons/Copy";
import LeftArrow from "../../../UI/Icons/LeftArrow";

const VacancyHeader = ({
  selectedVacancyDetails,
  onBack,
  onDuplicate,
  onCancel,
}: {
  selectedVacancyDetails: TVacancy | null;
  onBack: () => void;
  onDuplicate: () => void;
  onCancel: () => void;
}) => (
    
  <div className="d-flex flex-column flex-lg-row gap-10 align-items-center justify-content-between">
    <div className="d-flex mobile-w-100">
      <CustomButton
        variant={"primary"}
        type="button"
        className="btn-theme bg-off-white text-black text-nowrap mobile-w-100"
        onClick={onBack}
      >
        <LeftArrow />
        Back to Vacancies
      </CustomButton>
    </div>
    <div className="d-flex flex-column flex-lg-row gap-10 align-items-center mobile-w-100">
      <CustomButton
        variant={"primary"}
        type="button"
        className="btn-theme bg-off-white text-black mobile-w-100"
        onClick={onDuplicate}
      >
        <Copy />
        Duplicate as New Vacancy
      </CustomButton>
      {selectedVacancyDetails?.vacancy_current_status !== "expired" && (
        <CustomButton
          variant={"primary"}
          type="button"
          className="btn-theme bg-off-white text-black mobile-w-100"
          onClick={onCancel}
        >
          <Block />
          Cancel Vacancy
        </CustomButton>
      )}
    </div>
  </div>
);

export default VacancyHeader;
